import type { SVGProps } from "react";

const ScrollTextIcon = (props: SVGProps<SVGSVGElement>) => {
  const { color, ...rest } = props;
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      aria-labelledby="scrollTextTitle"
      {...rest}
    >
      <title id="scrollTextTitle">Scroll Text</title>
      <path d="M15 12h-5" stroke={color ?? "#71717A"} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M15 8h-5" stroke={color ?? "#71717A"} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M19 17V5a2 2 0 0 0-2-2H4" stroke={color ?? "#71717A"} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
      <path d="M8 21h12a2 2 0 0 0 2-2v-1a1 1 0 0 0-1-1H11a1 1 0 0 0-1 1v1a2 2 0 1 1-4 0V5a2 2 0 1 0-4 0v2a1 1 0 0 0 1 1h3" stroke={color ?? "#71717A"} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  );
};

export default ScrollTextIcon;
